import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { attrs: { "data-qa": "laboratories-list-content-skeleton" } },
    _vm._l(12, function (i) {
      return _c(VSkeletonLoader, {
        key: i,
        staticClass: "laboratories-skeleton",
        attrs: { type: "list-item-two-line" },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }